import { getMessageFromError } from '../utils/functions'

const PREFIX = 'admin/dashboard'
const ANALYTICS_LOG_PREFIX = 'admin/analytics-log'
export default {
  /* -------------------------------------------------------------------------- */
  /*                                Dashboard Counts                            */
  /* -------------------------------------------------------------------------- */
  async counts({ commit }, data) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.get(`${PREFIX}/counts`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'record',
        data: res.data.data
      })
      return {
        message: res.data
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      // Manage Error
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                                Orders Counts                            */
  /* -------------------------------------------------------------------------- */
  async orderCounts({ commit }, params) {
    commit('SET_STATE', {
      action: 'orderCountLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${PREFIX}/total-revenue`, { params })
      commit('SET_STATE', {
        action: 'orderCountLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'orderCountRecord',
        data: res.data.data
      })
      return {
        message: res.data
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'orderCountLoading',
        data: false
      })
      // Manage Error
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                                Analytics Counts                            */
  /* -------------------------------------------------------------------------- */
  async analyticsCounts({ commit }, params) {
    commit('SET_STATE', {
      action: 'analyticsLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${ANALYTICS_LOG_PREFIX}/counts`, { params })
      commit('SET_STATE', {
        action: 'analyticsLoading',
        data: false
      })
      commit('SET_STATE', {
        action: 'analyticsCounts',
        data: res.data.data
      })
      return {
        message: res.data
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'analyticsLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  /* -------------------------------------------------------------------------- */
  /*                                Analytics List                              */
  /* -------------------------------------------------------------------------- */
  async analyticsList({ commit }, params) {
    commit('SET_STATE', {
      action: 'analyticsListLoading',
      data: true
    })
    try {
      const res = await this.$http.get(`${ANALYTICS_LOG_PREFIX}/list`, { params })
      commit('SET_STATE', {
        action: 'analyticsListLoading',
        data: false
      })

      commit('SET_STATE', {
        action: 'analyticsListRecords',
        data: (res.data.data && res.data.data.results) || []
      })
      commit('SET_STATE', {
        action: 'analyticsListTotal',
        data: (res.data.data && res.data.data.totalResults) || 0
      })
      commit('SET_STATE', {
        action: 'analyticsListFilteredCount',
        data: (res.data.data && res.data.data.totalResults) || 0
      })
      return {
        message: res.data
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'analyticsListLoading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  }
}
